import React, { useEffect, useRef, useState } from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { DropdownPortal } from './ScoreFilterDropdown';

export default function MetaFilterDropdown({

  id,

  label,

  value,

  options,

  isOpen,

  onToggleOpen,

  onRequestClose,

  onChange,

  inverted = false,

}) {

  const [anchor, setAnchor] = useState(null);

  const buttonRef = useRef(null);

  const hasValue = value != null && String(value).trim() !== '';



  useEffect(() => {

    if (isOpen && buttonRef.current) {

      const rect = buttonRef.current.getBoundingClientRect();

      const optionCount = Array.isArray(options) ? options.length : 0;

      const estimatedMenuHeight = optionCount * 36 + 56;

      const spaceBelow = window.innerHeight - rect.bottom;

      const shouldOpenUpwards = spaceBelow < estimatedMenuHeight;

      setAnchor({

        right: window.innerWidth - rect.right,

        top: shouldOpenUpwards ? undefined : rect.bottom,

        bottom: shouldOpenUpwards ? window.innerHeight - rect.top : undefined,

      });

    }

    if (!isOpen && anchor !== null) setAnchor(null);

  }, [isOpen, anchor, options]);



  const handleToggle = () => onToggleOpen(id);

  const handleSelect = (v) => {

    onChange(v);

    onRequestClose();

  };

  const handleClear = (e) => {

    e.stopPropagation();

    onChange(null);

    onRequestClose();

  };



  const buttonClass = inverted

    ? `ml-1.5 inline-flex items-center justify-center rounded-lg p-1.5 focus:outline-none focus:ring-2 focus:ring-white/50 transition-colors ${

        hasValue ? 'text-white bg-white/20 hover:bg-white/30' : 'text-white/90 hover:bg-white/15'

      }`

    : `ml-1.5 inline-flex items-center justify-center rounded-lg p-1.5 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#007BFF]/30 transition-colors ${

        hasValue ? 'text-[#007BFF]' : 'text-gray-500'

      }`;



  return (

    <>

      <button

        ref={buttonRef}

        type="button"

        onClick={handleToggle}

        className={buttonClass}

        title={hasValue ? `${label}: ${value}` : `Filter by ${label}`}

        aria-haspopup="listbox"

        aria-expanded={isOpen}

      >

        <span className="relative inline-flex">

          <FunnelIcon className="h-4 w-4" />

          {hasValue && (

            <span

              className={`absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full ${

                inverted ? 'bg-white' : 'bg-[#007BFF] border border-white'

              }`}

              aria-hidden

            />

          )}

        </span>

      </button>

      {isOpen && anchor && (

        <DropdownPortal>

          <div role="presentation" className="fixed inset-0 z-40" onClick={onRequestClose} aria-hidden />

          <div

            style={{

              position: 'fixed',

              right: anchor.right,

              top: anchor.top,

              bottom: anchor.bottom,

            }}

            className="z-50 mt-1.5 w-56 rounded-2xl bg-white shadow-xl border border-gray-200/90 overflow-hidden"

            role="listbox"

          >

            <div className="px-4 py-3 border-b border-gray-100 bg-gradient-to-b from-gray-50/90 to-white">

              <p className="text-sm font-semibold text-gray-800">{label}</p>

            </div>

            <div className="p-3 space-y-1.5 max-h-64 overflow-y-auto" role="radiogroup" aria-label={`Filter by ${label}`}>

              {(options || []).map((opt) => {

                const optValue = typeof opt === 'string' ? opt : opt?.value;

                const optLabel = typeof opt === 'string' ? opt : opt?.label ?? optValue;

                const active = value === optValue;

                return (

                  <label

                    key={String(optValue)}

                    className={`flex w-full cursor-pointer items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${

                      active ? 'bg-[#007BFF] text-white shadow-sm' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'

                    }`}

                  >

                    <input

                      type="radio"

                      name={`meta-filter-${id}`}

                      value={String(optValue)}

                      checked={active}

                      onChange={() => handleSelect(optValue)}

                      className={`h-4 w-4 flex-shrink-0 cursor-pointer ${

                        active ? 'accent-white border-2 border-white' : 'accent-[#007BFF] border-2 border-gray-400'

                      }`}

                      aria-checked={active}

                    />

                    <span className="flex-1 text-left">{optLabel}</span>

                  </label>

                );

              })}

            </div>

            <div className="px-3 pb-3 pt-1 border-t border-gray-100 bg-gray-50/50">

              <button

                type="button"

                onClick={handleClear}

                className="w-full rounded-xl px-3 py-2 text-sm font-medium text-[#007BFF] hover:bg-[#007BFF]/10 transition-colors"

              >

                Clear filter

              </button>

            </div>

          </div>

        </DropdownPortal>

      )}

    </>

  );

}
